<template>
  <div id="Kft">
    <SovecoNavBar />
    <div class="tabs is-boxed is-marginless">
      <ul class="vehicles_top_tabs">
        <li :class="isTabActive(0)" @click="clickTab(0)">
          <a>Veicolo Carburante e Km</a>
        </li>
        <li :class="isTabActive(1)" @click="clickTab(1)">
          <a>Flotta Consumo e Km</a>
        </li>
        <li :class="isTabActive(2)" @click="clickTab(2)">
          <a>Statistiche Veicolo</a>
        </li>
      </ul>
    </div>
    <template v-if="tabNo === 0">
      <div class="columns">
        <div class="column is-narrow">
          <RangeDate
            :sData="startData"
            :eData="endData"
            :mode="'date'"
            :vehicles="kftVehicles"
            :isLoading="isLoading"
            :vehicleVis="true"
          />
        </div>
        <div class="column">
          <div v-if="isLoadingGraph" class="spinner">
            <VueElementLoading
              :active="isLoadingGraph"
              spinner="ring"
              color="#0000FF"
              background-color="lightgray"
            />
          </div>
          <div id="graphBox" class="sboxx">
            <div class="sbox-inner">
              <div
                class="graphArea pb-3"
                v-for="item in chartDataCollection"
                :key="item.id"
              >
                <h2 class="has-text-weight-bold">
                  <span class="pr-3">{{ item.date }}</span>
                  <span>{{ item.vehicle }}</span>
                </h2>
                <GChart
                  v-if="chartDataCollection.length > 0"
                  :settings="{ packages: ['corechart'] }"
                  type="AreaChart"
                  :data="item.data"
                  :options="optionsChart"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-if="tabNo === 1">
      <div>
        <div class="columns">
          <div class="column is-narrow">
            <RangeDate
              :sData="startData"
              :eData="endData"
              :mode="'date'"
              :vehicles="kftVehicles"
              :isLoading="isLoading"
              :vehicleVis="false"
            />
          </div>
          <div class="column">
            <div v-if="isLoadingGraph" class="spinner">
              <VueElementLoading
                :active="isLoadingGraph"
                spinner="ring"
                color="#0000FF"
                background-color="white"
              />
            </div>
            <GChart
              v-if="chartDataCollection.length > 0"
              :settings="{ packages: ['corechart'] }"
              type="BarChart"
              :data="chartDataCollection[0]"
              :options="optionsChart"
            />
          </div>
        </div>
      </div>
    </template>
    <template v-if="tabNo === 2">
      <div>
        <div class="columns">
          <div class="column is-narrow">
            <RangeDate
              :sData="startData"
              :eData="endData"
              :mode="'nodate'"
              :vehicles="kftVehicles"
              :isLoading="isLoading"
              :vehicleVis="true"
            />
          </div>
          <div class="column">
            <div v-if="isLoadingStats" class="spinner">
              <VueElementLoading
                :active="isLoadingGraph"
                spinner="ring"
                color="#0000FF"
                background-color="white"
              />
            </div>
            <div v-if="isReadyStats">
              <div class="box">
                {{ currentVehicle.RegistrationPlate }}&nbsp;{{
                  currentVehicle.Producer
                }}&nbsp;{{ currentVehicle.Model }}
                <br />
                Periodo dal {{ startData | date_reversesolo_filter }} fino al
                {{ endData | date_reversesolo_filter }}
              </div>
              <div class="box">
                <div class="columns">
                  <div class="column is-one-fifth">Km percorsi</div>
                  <div class="column is-narrow">
                    {{ Distance.toFixed(2) }}&nbsp;Km
                  </div>
                </div>
                <div class="columns">
                  <div class="column is-one-fifth">Carburante</div>
                  <div class="column is-narrow">
                    {{ FinalTachoLiter.toFixed(2) }}&nbsp;L
                  </div>
                </div>

                <div class="columns">
                  <div class="column is-one-fifth">Consumo Km/L</div>
                  <div class="column is-narrow">
                    {{ consumoKML.toFixed(2) }}&nbsp;Km/L
                  </div>
                </div>
              </div>

              <div class="box">
                <div class="columns">
                  <div class="column is-one-fifth">Velocità Max</div>
                  <div class="column is-narrow">{{ MaxSpeed }}&nbsp;Km/h</div>
                </div>

                <div class="columns">
                  <div class="column is-one-fifth">Giri Motore Max</div>
                  <div class="column is-narrow">{{ MaxRpm }}&nbsp;RPM</div>
                </div>

                <div class="columns">
                  <div class="column is-one-fifth">Temperatura Max Motore</div>
                  <div class="column is-narrow">
                    {{ MaxEngineTemp }}&nbsp;C°
                  </div>
                </div>
              </div>

              <div class="box">
                <div class="columns">
                  <div class="column is-one-fifth">
                    Chiave inserita motore spento
                  </div>
                  <div class="column is-narrow">
                    {{ TimeInKeyOnEngOff | seconds_hhmmss }}&nbsp;HH:MM:SS
                  </div>
                </div>

                <div class="columns">
                  <div class="column is-one-fifth">Motore Acceso in Sosta</div>
                  <div class="column is-narrow">
                    {{
                      TimeInKeyOnEngOnNotMoving | seconds_hhmmss
                    }}&nbsp;HH:MM:SS
                  </div>
                </div>

                <div class="columns">
                  <div class="column is-one-fifth">Motore Acceso in Marcia</div>
                  <div class="column is-narrow">
                    {{
                      TimeInKeyOnEngOnAndMoving | seconds_hhmmss
                    }}&nbsp;HH:MM:SS
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import { ServiceBus } from '../ServiceBus.js'
import axios from 'axios'
import { UtilityMixin } from '../mixins/UtilityMixin.js'
//import VueScrollTable from "./reusable/VueScrollTable.vue";
import RangeDate from './reusable/RangeDate.vue'
import VueElementLoading from 'vue-element-loading'
import { GChart } from 'vue-google-charts'
//import DatePicker from "vue2-datepicker";
import 'vue2-datepicker/index.css'
import 'vue2-datepicker/locale/it'

export default {
  name: 'Fms',
  components: {
    GChart,
    // VueScrollTable,
    VueElementLoading,
    RangeDate,
    // DatePicker
  },
  mixins: [UtilityMixin],
  data() {
    return {
      myChart: null,
      isLoading: false,
      isLoadingGraph: false,
      isLoadingStats: false,
      tabNo: 0,
      apiServer: '',
      startData: '',
      endData: '',
      auth: null,
      prefs: null,
      kftVehicles: [],
      deviceData: [],
      windowHeight: 0,
      isHovering: {},
      rowsGraph: [],
      optionsChart: {},
      chartDataCollection: [],
      currentVehicle: null,

      isReadyStats: false,
      MaxSpeed: 0,
      MaxRpm: 0,
      MaxEngineTemp: 0,
      Distance: 0,
      FinalTachoLiter: 0,
      PrevTachoLiter: 0,
      TimeInKeyOnEngOff: 0,
      TimeInKeyOnEngOnNotMoving: 0,
      TimeInKeyOnEngOnAndMoving: 0,
      consumoKML: 0,
    }
  },
  created() {
    const vm = this
    let d = new Date()
    vm.endData = d.toLocaleMysqlString()
    d.setDate(d.getDate() - 1)
    d.setHours(0)
    d.setMinutes(0)
    d.setSeconds(0)
    vm.startData = d.toLocaleMysqlString()
    vm.prefs = JSON.parse(vm.$localStorage.get('prefs'))
    vm.auth = JSON.parse(vm.$localStorage.get('auth'))
  },
  mounted() {
    const vm = this
    vm.api_server = vm.getApiServer()
    vm.api_serverKft = vm.getKFTServer()
    if (vm.auth === null || vm.auth.tipo == 3) {
      this.$router.push({
        path: 'login',
      })
    }

    ServiceBus.$on('setRangeDate', (obj) => {
      vm.startData = obj.startData
      vm.endData = obj.endData
      vm.currentVehicle = obj.item
      vm.isReadyStats = false
      switch (vm.tabNo) {
        case 0:
          vm.doGraphCarburanteAlt(obj.item)
          break
        case 1:
          vm.doGraphFlotta()
          break
        case 2:
          vm.doGraphStats(obj.item)
          break
      }
    })

    vm.$nextTick(function () {
      window.removeEventListener('resize', null)
      window.addEventListener('resize', vm.getWindowHeight)

      if (!vm.auth.flag_kft) {
        let lg = vm.nullString(vm.auth.login_kft)
        let pw = vm.nullString(vm.auth.password_kft)
        if (lg.length > 0 && pw.length > 0) {
          vm.$dialog
            .alert('Riprova il collegamento con il server KFT')
            .then(function (dialog) {
              vm.checkKFTServer()
            })
        } else {
          this.$dialog
            .alert('Servizio cronotachigrafo non attivato per ' + vm.auth.nome)
            .then(function (dialog) {
              vm.$router.push({ name: 'Map', params: { pcod: '' } })
            })
        }
      }
      vm.fillDate()
      vm.clickTab(0)
      vm.getWindowHeight(null)
    })
  },
  methods: {
    fillDate() {
      const vm = this
      let d = new Date()
      vm.endData = d.toLocaleMysqlString().split(' ')[0]
      d.setDate(d.getDate() - 1)
      d.setHours(0)
      d.setMinutes(0)
      d.setSeconds(0)
      vm.startData = d.toLocaleMysqlString().split(' ')[0]
    },
    clickTab(t) {
      let d
      const vm = this
      switch (t) {
        case 0:
          vm.tabNo = t
          setTimeout(function () {
            vm.getWindowHeight(null)
          }, 500)
          vm.GetListKFTVehicles()
          break
        case 1:
          vm.tabNo = t
          setTimeout(function () {
            vm.getWindowHeight(null)
          }, 500)
          break
        case 2:
          vm.tabNo = t
          setTimeout(function () {
            vm.getWindowHeight(null)
          }, 500)
          vm.GetListKFTVehicles()
          break
      }
    },
    get_image(id, value) {
      let img_link
      if (id == 'DDDType') {
        switch (value) {
          case 'C':
            img_link = './images/delivery-man.png'
            break
          case 'M':
            img_link = './images/truck.png'
            break
        }
      }
      return img_link
    },
    isTabActive(t) {
      const vm = this
      if (vm.tabNo == t) {
        return 'is-active'
      } else {
        return ''
      }
    },

    async doGraphStats(item) {
      const vm = this
      vm.isReadyStats = false
      vm.MaxSpeed = 0
      vm.MaxRpm = 0
      vm.MaxEngineTemp = 0
      vm.Distance = 0
      vm.FinalTachoLiter = 0
      vm.PrevTachoLiter = 0
      vm.TimeInKeyOnEngOff = 0
      vm.TimeInKeyOnEngOnNotMoving = 0
      vm.TimeInKeyOnEngOnAndMoving = 0
      vm.isLoadingStats = true
      vm.consumoKML = 0
      vm.chartDataCollection = []
      await vm.doGetListDeviceData(item.PerifId)
      if (vm.deviceData.length > 0) {
        vm.deviceData.forEach((element) => {
          if (element.MaxSpeed > vm.MaxSpeed) {
            vm.MaxSpeed = element.MaxSpeed
          }
          if (element.MaxRpm > vm.MaxRpm) {
            vm.MaxRpm = element.MaxRpm
          }
          if (element.MaxEngineTemp > vm.MaxEngineTemp) {
            vm.MaxEngineTemp = element.MaxEngineTemp
          }
          vm.Distance += element.Distance
          vm.TimeInKeyOnEngOff += element.TimeInKeyOnEngOff
          vm.TimeInKeyOnEngOnNotMoving += element.TimeInKeyOnEngOnNotMoving
          vm.TimeInKeyOnEngOnAndMoving += element.TimeInKeyOnEngOnAndMoving
          if (vm.PrevTachoLiter > 0) {
            vm.FinalTachoLiter += element.FinalTachoLiter - vm.PrevTachoLiter
          }
          vm.PrevTachoLiter = element.FinalTachoLiter
        })
        vm.consumoKML = vm.Distance / vm.FinalTachoLiter
      }
      vm.isLoadingStats = false
      vm.isReadyStats = true
    },

    async doGraphFlotta() {
      const vm = this
      vm.isLoadingGraph = true
      vm.chartDataCollection = []
      await vm.doGetListDeviceData(null)

      vm.optionsChart = {
        title:
          'FLOTTA KM PERCORSI E CONSUMO CARBURANTE : ' +
          vm.reverseDateSolo(vm.startData) +
          ' - ' +
          vm.reverseDateSolo(vm.endData),
        height: 700,
        vAxis: {
          title: 'Veicoli',
          titleTextStyle: { color: '#333' },
          textStyle: { fontSize: 11 },
        },

        hAxes: {
          0: {
            format: '# Km/L',
            gridlines: { color: 'transparent' },
            textStyle: {
              fontSize: 11, // or the number you want
            },
          },
          1: {
            format: '# ',
            gridlines: { color: 'lightgrey' },
            textStyle: {
              fontSize: 11, // or the number you want
            },
          },
        },
        series: {
          0: { targetAxisIndex: 1 },
          1: { targetAxisIndex: 1 },
          2: { targetAxisIndex: 0 },
        },
        colors: ['green', 'blue', 'red'],
      }

      if (vm.deviceData.length > 0) {
        let vehicle

        vm.kftVehicles.forEach((element) => {
          element.tot_distance = 0
          element.prev_liters = 0
          element.tot_liters = 0
          element.kml = 0
        })

        vm.deviceData.forEach((element) => {
          vehicle = vm.kftVehicles.find(
            (obj) => obj.PerifId === element.PerifId
          )

          if (vehicle !== null || vehicle !== undefined) {
            if (vehicle.prev_liters > 0) {
              vehicle.tot_liters +=
                element.FinalTachoLiter - vehicle.prev_liters
            }
            vehicle.prev_liters = element.FinalTachoLiter
            vehicle.tot_distance += element.Distance
          }
        })

        vm.deviceData = []
        let temp = []

        temp.push(['Targa', 'Km', 'Litri', 'Km/L'])
        vm.kftVehicles.forEach((element) => {
          element.kml = element.tot_distance / element.tot_liters
          temp.push([
            element.RegistrationPlate,
            element.tot_distance,
            element.tot_liters,
            element.kml,
          ])
        })

        vm.chartDataCollection.push(temp)
      }
      vm.isLoadingGraph = false
    },

    async doGraphCarburanteAlt(item) {
      const vm = this
      vm.currentVehicle = item
      vm.isLoadingGraph = true
      vm.chartDataCollection = []
      await vm.doGetListDeviceData(item.PerifId)
      if (vm.deviceData.length > 0) {
        let dates = [
          ...new Set(
            vm.deviceData.map(
              (item) => item.DateYYYY + '-' + item.DateMM + '-' + item.DateDD
            )
          ),
        ]
        let oneGraph = []
        vm.rowsGraph = []
        let temp
        let tempObj

        for (let i = 0; i < dates.length; i++) {
          temp = []
          temp = vm.deviceData.filter(function (item) {
            return (
              item.DateYYYY + '-' + item.DateMM + '-' + item.DateDD === dates[i]
            )
          })
          vm.rowsGraph.push(temp)
        }
        vm.deviceData = []
        vm.optionsChart = {
          title: '',
          height: 300,
          hAxis: {
            title: '',
            titleTextStyle: { color: '#333' },
            format: 'HH:mm',
            textStyle: { fontSize: 9 },
          },
          vAxes: {
            0: {
              viewWindowMode: 'explicit',
              viewWindow: {
                max: 100,
                min: 0,
              },
              format: '# Km/h',
              gridlines: { color: 'transparent' },
              textStyle: {
                fontSize: 10, // or the number you want
              },
            },
            1: {
              gridlines: { color: 'lightgrey' },
              textStyle: {
                fontSize: 10, // or the number you want
              },
            },
          },
          series: {
            0: { targetAxisIndex: 1 },
            1: { targetAxisIndex: 1 },
            2: { targetAxisIndex: 0 },
          },
          colors: ['green', 'blue', 'red'],
        }

        vm.optionsChart.width = vm.grapBoxWidth - 40

        let tot_distance = 0
        let tot_liters = 0
        let prev_liters = 0

        for (let i = 0; i < vm.rowsGraph.length; i++) {
          oneGraph = vm.rowsGraph[i]
          temp = []

          temp.push(['', 'Litri', 'Km', 'Km/h'])

          for (let x = 0; x < oneGraph.length; x++) {
            tot_distance += parseInt(oneGraph[x].Distance, 10)
            if (prev_liters == 0) {
              prev_liters = parseInt(oneGraph[x].FinalTachoLiter, 10)
            }
            tot_liters = parseInt(oneGraph[x].FinalTachoLiter, 10) - prev_liters

            temp.push([
              oneGraph[x].FinalDate.split('T')[1],
              tot_liters,
              tot_distance,
              oneGraph[x].MaxSpeed,
            ])
          }
          tempObj = {}
          tempObj.date = vm.reverseDateSolo(dates[i])
          tempObj.vehicle = item.RegistrationPlate + ' ' + item.Producer
          tempObj.id = i
          tempObj.data = temp
          vm.chartDataCollection.push(tempObj)
        }
      }
      vm.rowsGraph = []
      vm.isLoadingGraph = false
      if (vm.chartDataCollection.length < 1) {
        vm.$dialog
          .alert('Nessun dato presente per questo mezzo in questo periodo')
          .then(function (dialog) {})
      }
    },

    async doGraphCarburante(item) {
      const vm = this
      vm.currentVehicle = item
      vm.isLoadingGraph = true
      vm.chartDataCollection = []
      await vm.doGetListFuelSingleTank(item)
      if (vm.deviceData.length > 0) {
        let dates = [
          ...new Set(
            vm.deviceData.map(
              (item) => item.DateYYYY + '-' + item.DateMM + '-' + item.DateDD
            )
          ),
        ]
        let oneGraph = []
        vm.rowsGraph = []
        let temp
        let tempObj

        for (let i = 0; i < dates.length; i++) {
          temp = []
          temp = vm.deviceData.filter(function (item) {
            return (
              item.DateYYYY + '-' + item.DateMM + '-' + item.DateDD === dates[i]
            )
          })
          vm.rowsGraph.push(temp)
        }
        vm.deviceData = []
        vm.optionsChart = {
          title: '',
          height: 300,
          hAxis: {
            title: '',
            titleTextStyle: { color: '#333' },
            format: 'HH:mm',
            textStyle: { fontSize: 9 },
          },
          vAxes: {
            0: {
              viewWindowMode: 'explicit',
              viewWindow: {
                max: 100,
                min: 0,
              },
              format: '# Km/h',
              gridlines: { color: 'transparent' },
              textStyle: {
                fontSize: 10, // or the number you want
              },
            },
            1: {
              gridlines: { color: 'lightgrey' },
              textStyle: {
                fontSize: 10, // or the number you want
              },
            },
          },
          series: {
            0: { targetAxisIndex: 1 },
            1: { targetAxisIndex: 1 },
            2: { targetAxisIndex: 0 },
          },
          colors: ['green', 'blue', 'red'],
        }

        vm.optionsChart.width = vm.grapBoxWidth - 40

        for (let i = 0; i < vm.rowsGraph.length; i++) {
          oneGraph = vm.rowsGraph[i]
          temp = []

          temp.push(['', 'Litri', 'Km', 'Km/h'])

          for (let x = 0; x < oneGraph.length; x++) {
            temp.push([
              oneGraph[x].Date.split('T')[1],
              oneGraph[x].SensorFuelMainTank,
              oneGraph[x].StoryTotalDistance,
              oneGraph[x].Speed,
            ])
          }

          tempObj = {}
          tempObj.date = vm.reverseDateSolo(dates[i])
          tempObj.vehicle = item.RegistrationPlate + ' ' + item.Producer
          tempObj.id = i
          tempObj.data = temp
          vm.chartDataCollection.push(tempObj)
        }
      }
      vm.rowsGraph = []
      vm.isLoadingGraph = false
      if (vm.chartDataCollection.length < 1) {
        vm.$dialog
          .alert('Nessun dato presente per questo mezzo in questo periodo')
          .then(function (dialog) {})
      }
    },
    async checkKFTServer() {
      const vm = this
      await vm.doLoginKft()
    },
    async doLoginKft() {
      const vm = this
      try {
        const response = await axios.post(
          vm.api_server + 'loginkft',
          {
            group: 'SV',
            password: vm.auth.password_kft,
            name: vm.auth.login_kft,
            token: '',
          },
          {
            headers: {
              Authorization: vm.auth.tkn,
            },
          }
        )
        if (response.data.login === 'ok') {
          vm.auth.tkn_kft = response.data.token
          vm.auth.flag_kft = true
          this.$dialog
            .alert('Collegamento con il server KFT riattivato.')
            .then(function (dialog) {})
        } else {
          this.$dialog
            .alert(
              'Errore di connessione con il server KFT. Controllare login o password KFT'
            )
            .then(function (dialog) {})
        }
      } catch (e) {
        console.log('error ' + e)
      }
    },

    async GetListKFTVehicles() {
      const vm = this

      vm.isLoading = true
      try {
        const response = await axios.post(
          vm.api_server + 'GetListKFTVehicles',
          {
            token: vm.auth.tkn_kft,
          },
          {
            headers: {
              Authorization: vm.auth.tkn,
            },
          }
        )
        if (vm.checkTkn(response.data)) {
          vm.kftVehicles = response.data.data
          vm.isLoading = false
        }
      } catch (e) {
        console.log('error ' + e)
        vm.isLoading = false
      }
    },

    async doGetListDeviceData(perifid) {
      const vm = this
      vm.deviceData = []
      vm.isLoading = true
      let start = vm.newDate(vm.startData).toLocaleMysqlSpecialString(false)
      let end = vm.newDate(vm.endData).toLocaleMysqlSpecialString(true)

      try {
        const response = await axios.post(
          vm.api_server + 'GetListDeviceData',
          {
            token: vm.auth.tkn_kft,
            PerifId: perifid,
            DateFrom: start,
            DateTo: end,
          },
          {
            headers: {
              Authorization: vm.auth.tkn,
            },
          }
        )
        if (vm.checkTkn(response.data)) {
          vm.deviceData = response.data.data
          vm.isLoading = false
        }
      } catch (e) {
        console.log('error ' + e)
        vm.isLoading = false
      }
    },

    async doGetListFuelSingleTank(vehicle) {
      const vm = this

      let start = vm.newDate(vm.startData).toLocaleMysqlSpecialString(false)
      let end = vm.newDate(vm.endData).toLocaleMysqlSpecialString(true)
      try {
        const response = await axios.post(
          vm.api_server + 'GetListFuelSingleTank',
          {
            token: vm.auth.tkn_kft,
            PerifId: vehicle.PerifId,
            DateFrom: start,
            DateTo: end,
          },
          {
            headers: {
              Authorization: vm.auth.tkn,
            },
          }
        )
        if (vm.checkTkn(response.data)) {
          vm.deviceData = response.data.data
        }
      } catch (e) {
        console.log('error ' + e)
      }
    },
    getWindowHeight(event) {
      const vm = this
      vm.windowHeight = document.documentElement.clientHeight
      let value
      let ele1 = document.getElementById('rangecontainer')
      let ele3 = document.getElementById('rangecontent')
      if (ele1) {
        if (vm.tabNo === 2) {
          value = 210
        } else {
          value = 300
        }
        ele1.setAttribute('style', 'height:' + (vm.windowHeight - value) + 'px')
      }
      if (ele3) {
        ele3.setAttribute(
          'style',
          'height:' + (vm.windowHeight - value - 40) + 'px'
        )
      }
      let ele2 = document.getElementById('graphBox')
      if (ele2) {
        ele2.setAttribute('style', 'height:' + (vm.windowHeight - 125) + 'px')
        vm.grapBoxWidth = ele2.offsetWidth
      }
    },
    beforeDestroy() {
      const vm = this
      window.removeEventListener('resize', vm.getWindowHeight)
    },
  },
}
</script>
